import { PILLARS } from '../data/pillars.js'

/**
 * Generic placeholder used by every pillar until it's ported.
 *
 * Future sessions will replace this with real components per pillar:
 *   src/pillars/EoBuyoutsPillar.jsx
 *   src/pillars/RevenuePillar.jsx
 *   src/pillars/GrowthPillar.jsx
 *   src/pillars/DeliveryPillar.jsx
 *   src/pillars/TeamPillar.jsx
 *   src/pillars/AiSystemsPillar.jsx
 */
export default function PillarPlaceholder({ pillarId }) {
  const pillar = PILLARS.find((p) => p.id === pillarId) || PILLARS[0]

  return (
    <div className="placeholder-card">
      <div className="placeholder-badge">Pillar not yet ported</div>
      <h2 style={{ color: pillar.color }}>
        {pillar.icon} {pillar.name}
      </h2>
      <p>
        This pillar will be ported in a future session. It'll have the same
        {' '}{pillar.goalCount} goal{pillar.goalCount === 1 ? '' : 's'} as the
        current <code>q2-goals.html</code>, wired to the same KV store so data
        stays in sync between the old and new dashboards during the migration.
      </p>
      <p style={{ marginTop: 12, fontSize: 12, color: 'var(--muted-light)' }}>
        In the meantime, use{' '}
        <a href="#" style={{ color: 'var(--accent)', fontWeight: 600 }}>
          the current dashboard
        </a>{' '}
        for live data.
      </p>
    </div>
  )
}
